__turbopack_context__.v({
  "className": "dm_sans_590763a2-module__ngscCq__className",
});
